import { Box } from "@mui/material";
import { InfoIconTooltip } from "components/InfoIconTooltip";

/** "Vendor" isn't a RCRA term (the data can come from the transporter, the
 * TSDF, or a subcontractor), so grids that show it explain what it means. */
export const VENDOR_COLUMN_TOOLTIP =
  "Vendor refers to the entity that provides manifest data to Encamp; i.e. the entity your organization has contracted with to manage waste.";

/** Fits the label, the info button, and the grid's sort and menu icons that
 * appear on hover; narrower columns hide the label entirely. */
export const VENDOR_COLUMN_MIN_WIDTH = 150;

export const VendorColumnHeader = () => (
  <Box sx={{ display: "flex", alignItems: "center", fontWeight: "medium" }}>
    Vendor
    <InfoIconTooltip
      tooltip={VENDOR_COLUMN_TOOLTIP}
      fontSize="small"
      ariaLabel="What does Vendor mean?"
    />
  </Box>
);
